
















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import slugify from 'slugify';
import { ApiResponse } from '@/components/types';
import { InternalAccountDetails } from '@/modules/listOfAssets/types';
import { FETCH_INTERNAL_ACCOUNT, GET_INTERNAL_ACCOUNT } from '@/modules/listOfAssets/store/internalAccount';
import CardRow from '@/components/CardRow.vue';
import FinanceAccountOpenedDialog from '../components/details/dialogs/FinanceAccountOpenedDialog.vue';
import FinanceAccountStartDepositDialog from '../components/details/dialogs/FinanceAccountStartDepositDialog.vue';
import FinanceAccountCloseDialog from '@/modules/listOfAssets/components/details/dialogs/FinanceAccountCloseDialog.vue';
import TransactionExportDialog from '@/modules/listOfAssets/components/TransactionExportDialog.vue';
import TransactionCard from '@/modules/listOfAssets/components/details/cards/TransactionCard.vue';
import InternalAccountDialog from '../components/details/dialogs/InternalAccountDialog.vue';
import VoucherExportDialog from '@/modules/listOfAssets/components/VoucherExportDialog.vue';

const InternalAccount = namespace('listOfAssets/internalAccount');

@Component({
  components: {
    VoucherExportDialog,
    InternalAccountDialog,
    TransactionCard,
    TransactionExportDialog,
    FinanceAccountCloseDialog,
    FinanceAccountStartDepositDialog,
    FinanceAccountOpenedDialog,
    CardRow
  }
})
export default class InternalAccountDetailsView extends Vue {
  @InternalAccount.Action(FETCH_INTERNAL_ACCOUNT) fetchDetails!: (account: string) => Promise<ApiResponse>;
  @InternalAccount.Getter(GET_INTERNAL_ACCOUNT) getDetails!: (account: string) => InternalAccountDetails | undefined;

  get account(): InternalAccountDetails | undefined {
    return this.getDetails(this.$route.params['id']);
  }

  get backURL() {
    if (this.$route.query['referrer']) {
      return this.$route.query['referrer'];
    }

    if (!this.account) return '';

    return { name: 'list-of-assets-details', params: { id: this.account.listOfAssetsId } };
  }

  slugify(string: string | null) {
    if (!string) {
      string = 'Bargeldkonto';
    }

    return slugify(string);
  }

  @Watch('$route.params.id', { immediate: true })
  onIdChange() {
    return this.fetchDetails(this.$route.params['id']);
  }
}
